module.exports = __webpack_public_path__ + "img/supplier.b25ee4a6.svg";